export const getScrollPosition = (): number => window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

export const getDocumentTop = (element: Element): number => {
	let top = 0;
	let current: HTMLElement | null = element as HTMLElement;

	while (current) {
		const position = window.getComputedStyle?.(current).position;
		if (position === 'sticky' || position === 'fixed') {
			// offsetTop/offsetParent are unreliable once an element is sticky/fixed
			// (e.g. offsetParent can be null, or offsetTop can reflect the pinned
			// viewport position rather than the static document position). Fall back
			// to the live rect, which is accurate once scroll has settled. `top` so
			// far already holds the queried element's offset relative to `current`,
			// so add current's own document top on top of that.
			return top + current.getBoundingClientRect().top + getScrollPosition();
		}

		top += current.offsetTop + current.clientTop;
		current = current.offsetParent as HTMLElement | null;
	}

	return top;
};

export const getDocumentBounds = (element: Element): { top: number; bottom: number } => {
	const top = getDocumentTop(element);
	const height = (element as HTMLElement).offsetHeight || element.getBoundingClientRect().height;
	return { top, bottom: top + height };
};
